import { CountryIso3Code } from '../../models/country/country-iso-3-code.enum';
import { CountryIsoNumber } from '../../models/country/country-iso-number.enum';

export function countryIso3CodeFactory(
  countryIsoNumber: CountryIsoNumber,
): CountryIso3Code {
  switch (countryIsoNumber) {
    case CountryIsoNumber.Ireland:
      return CountryIso3Code.Ireland;
    case CountryIsoNumber.GreatBritain:
    default:
      return CountryIso3Code.GreatBritain;
  }
}
